import { Helmet } from "react-helmet-async";
import { site, office, hours } from "@/config/site";

export const abs = (path = "/") => `${site.domain}${path === "/" ? "/" : path}`;

const allDays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

// Organization / LocalBusiness-style entity. No review or aggregateRating markup is emitted on purpose:
// Google does not show review rich results for self-served reviews about the site's own organisation.
export const orgLd = {
  "@context": "https://schema.org",
  "@type": ["Organization", "ProfessionalService"],
  "@id": `${site.domain}/#organization`,
  name: site.name,
  url: `${site.domain}/`,
  logo: `${site.domain}${site.logo}`,
  image: `${site.domain}${site.ogImage}`,
  description: site.promise,
  email: site.email,
  telephone: site.phones[0],
  address: {
    "@type": "PostalAddress",
    streetAddress: office.street,
    addressLocality: office.city,
    addressRegion: office.region,
    postalCode: office.postalCode,
    addressCountry: office.countryCode,
  },
  ...(hours.open24Hours ? { openingHoursSpecification: [{ "@type": "OpeningHoursSpecification", dayOfWeek: allDays, opens: "00:00", closes: "23:59" }] } : {}),
  contactPoint: [{ "@type": "ContactPoint", contactType: "sales", email: site.email, telephone: site.phones[0], availableLanguage: ["English"], ...(hours.open24Hours ? { hoursAvailable: { "@type": "OpeningHoursSpecification", dayOfWeek: allDays, opens: "00:00", closes: "23:59" } } : {}) }],
};

export const Seo = ({ title, description, path = "/", type = "website", jsonLd = [], noindex = false }) => {
  const full = path === "/" ? title : `${title} | ${site.name}`;
  const url = abs(path);
  return (
    <Helmet prioritizeSeoTags>
      <title>{full}</title>
      <meta name="description" content={description} />
      {!noindex && <link rel="canonical" href={url} />}
      {noindex && <meta name="robots" content="noindex, follow" />}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={abs(site.ogImage)} />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:image" content={abs(site.ogImage)} />
      <meta name="twitter:description" content={description} />
      {jsonLd.map((ld, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(ld)}</script>
      ))}
    </Helmet>
  );
};

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.label, item: abs(it.to) })),
});

export const faqLd = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
});
